<template>
  <div class="page-container">
    
    <el-row :gutter="10">
      <el-col :span="selected === null ? 24 : 12">

        <div class="data-filter">
          <el-button size="mini" type="primary" @click="companyAddOpenHandler">업체 추가하기</el-button>
        </div>

        <div class="data-table">
          <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
            <el-table-column type="index" :index="rowIndex" width="120"></el-table-column>
            <el-table-column label="회사이름">
              <template slot-scope="scope">
                <span class="company-name" :class="{active: scope.row.pk === selected}" @click="setDetail(scope.row)">{{ scope.row.company_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="가입일" width="100">
              <template slot-scope="scope">{{ scope.row.join_date | moment('YYYY-MM-DD') }}</template>
            </el-table-column>
            <el-table-column label="담당자" width="90">
              <template slot-scope="scope">
                <el-popover placement="left" width="400" trigger="click">
                  <ul class="manager-information">
                    <li>
                      <div class="label">이름</div>
                      <div class="value">{{ scope.row.name }}</div>
                    </li>
                    <li>
                      <div class="label">이메일</div>
                      <div class="value">{{ scope.row.email || '없음' }}</div>
                    </li>
                    <li>
                      <div class="label">전화번호</div>
                      <div class="value">{{ scope.row.phone || '없음' }}</div>
                    </li>
                    <li>
                      <div class="label">웹사이트</div>
                      <div class="value">
                        <a v-if="scope.row.website" :href="scope.row.website" target="_blank">{{ scope.row.website }}</a>
                        <span v-else>웹사이트 없음</span>
                      </div>
                    </li>
                    <li>
                      <el-button size="mini" type="info" @click="companyUpdateOpenHandler(scope.row)">업체정보 변경</el-button>
                      <el-button size="mini" type="info" @click="registerOpenHandler(scope.row)">서비스 사용 등록</el-button>
                      <el-button size="mini" type="danger" @click="deleteCompanyOpenHandler(scope.row)">업체 삭제</el-button>
                    </li>
                  </ul>
                  <el-button slot="reference" size="mini">{{ scope.row.name }}</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="data-pagination">
          <el-pagination
            layout="prev, pager, next"
            :total="pagination.total"
            @current-change="pageHandler">
          </el-pagination>
        </div>
      </el-col>
      <el-col v-if="selected" :span="12">
        <div class="data-filter flex-between">
          <el-button size="mini" type="primary" @click="memodlg.show = true">메모 추가</el-button>
          <i class="el-icon-close memo-close" @click="selected = null"></i>
        </div>
        <el-card class="box-card" v-for="memo in memos" :key="memo.pk">
          <div class="card-header">
            <span>
              {{memo.type}} - 
              {{memo.create_time | moment('YYYY-MM-DD HH:mm:ss')}}
            </span>
            <div class="author">
              {{memo.manager}} &nbsp;
              <i class="el-icon-delete delete-memo-btn" @click="deleteMemo(memo)"></i>
            </div>
          </div>
          <div class="card-edit" v-if="memo.__edit">
            <div class="card-edit-func">
              <el-button size="mini" type="success" @click="saveEditMemo(memo)">저장</el-button>
              <el-button size="mini" type="" @click="closeEditMemo(memo)">닫기</el-button>
            </div>
            <el-input
              type="textarea"
              class="card-edit-form"
              autosize
              placeholder="메모를 입력해주세요"
              v-model="memo.__temp_memo">
            </el-input>
          </div>
          <div class="card-body" v-else @click="editMemo(memo)">{{memo.memo}}</div>
        </el-card>
        <el-card class="box-card" v-if="!memos.length">
          <div class="">메모가 없습니다</div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="company.show"
      width="30%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="@/assets/logo.png">
      </template>
      <div>
        <el-form ref="companyadd" :model="company.form" label-width="120px" :rules="company.rules">
          <el-form-item label="회사이름" prop="company_name">
            <el-input v-model="company.form.company_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="홈페이지" prop="website">
            <el-input v-model="company.form.website" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="담당자 이름" prop="name">
            <el-input v-model="company.form.name" autocomplete="off"/>
          </el-form-item>
          <el-form-item label="담당자 이메일" prop="email">
            <el-input v-model="company.form.email" type="email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="담당자 전화번호" prop="phone">
            <el-input v-model="company.form.phone" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="company.loading" @click="companyAddSubmitHandler">확인</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="register.show"
      width="60%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="@/assets/logo.png">
      </template>
      <div>
        <el-row>
          <el-col :span="12">
            <table class="company-info-table">
              <tr>
                <th>회사이름</th><td>: {{register.company.company_name}}</td>
              </tr>
              <tr>
                <th>홈페이지</th><td>: {{register.company.website}}</td>
              </tr>
              <tr>
                <th>담당자 이름</th><td>: {{register.company.name}}</td>
              </tr>
              <tr>
                <th>담당자 이메일</th><td>: {{register.company.email}}</td>
              </tr>
              <tr>
                <th>담당자 전화번호</th><td>: {{register.company.phone}}</td>
              </tr>
            </table>
          </el-col>
          <el-col :span="12">
            <el-form ref="companyenable" :model="register.form" label-width="120px" :rules="register.rules">
              <el-form-item label="관리자 ID" prop="mgrid">
                <el-input v-model="register.form.mgrid" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="관리자 PW" prop="mgrpw">
                <el-input v-model="register.form.mgrpw" autocomplete="off" type="password"></el-input>
              </el-form-item>
              <el-form-item label="관리자 이름" prop="name">
                <el-input v-model="register.form.name" autocomplete="off"/>
              </el-form-item>
              <el-form-item label="관리자 이메일" prop="email">
                <el-input v-model="register.form.email" type="email" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="register.loading" @click="registerSubmitHandler">확인</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="register.modal"
      width="30%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="@/assets/logo.png">
      </template>
      <span>서비스 사용 등록이 완료되었습니다.</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="registerDone(true)">등록정보 확인하기</el-button>
        <el-button @click="registerDone()">닫기</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="deleteCompany.show"
      width="30%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="@/assets/logo.png">
      </template>
      <span>"{{deleteCompany.company.company_name}}"을(를) 삭제하시겠습니까?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteCompanySubmitHandler(true)" :loading="deleteCompany.loading">삭제</el-button>
        <el-button @click="deleteCompanySubmitHandler()" :loading="deleteCompany.loading">취소</el-button>
      </span>
    </el-dialog>

    <dialog-memo v-model="memodlg.show" @close="dialogMemoHandler" />
  </div>
</template>

<script>
import DialogMemo from '@/components/Dialog-memo'
export default {
  components: {DialogMemo},
  methods: {
    async getManagers () {
      console.log('GET MANAGERS')
      try {
        this.loading = true
        let params = { offset: this.pagination.offset, limit: this.pagination.limit }
        // if (this.search) params.search = this.search
        // params.filter = 6

        let response = await this.$http.get('onprepare_company', {params})
        this.pagination.total = response.data.total
        this.list = response.data.list
        this.loading = false
        return response
      }
      catch (e) {
        console.error(e)
      }
    },
    async getMemo () {
      if (!this.selected) return;
      let query = {
        filters: [{name: 'company_fk', op: 'eq', val: this.selected}]
      }
      let params = { q: JSON.stringify(query) }
      let {data} = await this.$http.get('memo', {params})
      this.memos = data.objects.map(v => {
        v.__edit = false
        v.__temp_memo = v.memo
        return v
      })
      return;
    },
    async dialogMemoHandler (memo) {
      this.memodlg.show = false
      if (memo) {
        this.$service.localdb.setItem('admin_name', memo.manager)
        memo.company_fk = this.selected
        let {status} = await this.$http.post('memo', memo)
        if (status === 201) {
          this.getMemo()
          this.$message({
            message: '메모가 추가되었습니다',
            type: 'success'
          });
        }
      }
    },
    setDetail (company) {
      this.selected = company.pk
      this.getMemo()
    },
    async deleteMemo (memo) {
      let {status} = await this.$http.delete(`memo/${memo.pk}`)
      if (status === 204) {
        this.getMemo()
        this.$message({
          message: '메모가 삭제되었습니다',
          type: 'success'
        });
      }
    },
    async saveEditMemo (memo) {
      let params = {
        memo: memo.__temp_memo
      }
      let {status} = await this.$http.put(`memo/${memo.pk}`, params)
      if (status === 200) {
        this.$message({
          message: '메모가 수정되었습니다',
          type: 'success'
        });
        memo.memo = memo.__temp_memo
      }
      else {
        memo.__temp_memo = memo.memo
      }
      memo.__edit = false
    },
    closeEditMemo (memo) {
      memo.__temp_memo = memo.memo
      memo.__edit = false
    },
    editMemo (memo) {
      memo.__temp_memo = memo.memo
      memo.__edit = true
    },
    rowIndex (index) {
      let {total, offset} = this.pagination
      return total - (offset + index)
    },
    pageHandler (page) {
      this.pagination.offset = this.pagination.limit * (page - 1)
      this.getManagers()
    },
    filterHandler () {
      this.getManagers()
    },
    clearHandler () {
      this.search = null
      this.$router.replace({query: {}})
      this.getManagers()
    },
    companyUpdateOpenHandler (company) {
      if (!company) return;
      this.company.loading = false

      this.company.form.company_name = company.company_name
      this.company.form.website = company.website
      this.company.form.name = company.name
      this.company.form.email = company.email
      this.company.form.phone = company.phone
      this.company.form.enable = 'N'
      this.company.form.pk = company.pk

      this.company.show = true
    },
    companyAddOpenHandler () {
      this.company.loading = false

      this.company.form.company_name = ''
      this.company.form.website = ''
      this.company.form.name = ''
      this.company.form.email = ''
      this.company.form.phone = ''
      this.company.form.enable = 'N'
      this.company.form.pk = null

      this.company.show = true
      if (this.$refs.companyadd) this.$refs.companyadd.resetFields()
    },
    async companyAddSubmitHandler () {
      this.$refs.companyadd.validate(async (valid) => {
        if (!valid) return false
        this.company.loading = true

        try {
          let params = Object.assign({}, this.company.form)
          if (params.pk) {
            delete params.join_date
            await this.$http.put(`company_update/${params.pk}`, params)
            this.company.show = false
            this.company.loading = false
            this.$service.$emit('alert-modal', '업체 정보 변경에 성공했습니다')
          }
          else {
            params.join_date = this.$service.moment().format('YYYY-MM-DD HH:mm:ss')
            await this.$http.post('company_update', params)
            this.company.show = false
            this.company.loading = false
            this.$service.$emit('alert-modal', '업체 등록에 성공했습니다')
          }
          
          this.getManagers()
          return true
        }
        catch (e) {
          console.error(e)
          this.company.loading = false
          return false
        }
      })
    },
    registerOpenHandler (company) {
      this.register.loading = false
      this.register.modal = false

      this.register.company = company
      this.register.form.mgrid = ''
      this.register.form.mgrpw = ''
      this.register.form.name = ''
      this.register.form.email = ''
      this.register.form.company_fk = company.pk

      this.register.show = true
      if (this.$refs.companyenable) this.$refs.companyenable.resetFields()
    },
    async registerSubmitHandler () {
      this.$refs.companyenable.validate(async (valid) => {
        if (!valid) return false
        this.register.loading = true
        
        try {
          await this.$http.post('register_company', this.register.form)
          this.register.show = false
          this.register.loading = false
          this.register.modal = true
          return true
        }
        catch (e) {
          console.error(e)
          this.register.loading = false
          return false
        }
      })
    },
    registerDone (flag) {
      if (flag) {
        this.$router.push({name: 'management-detail', params: {company_pk: this.register.company.pk}})
      }
      else {
        this.getManagers()
        this.register.modal = false
      }
    },
    deleteCompanyOpenHandler (company) {
      if (!company) return;
      this.deleteCompany.company = company
      this.deleteCompany.loading = false
      this.deleteCompany.show = true
    },
    async deleteCompanySubmitHandler (flag) {
      if (flag) {
        this.deleteCompany.loading = true
        await this.$http.delete(`company_update/${this.deleteCompany.company.pk}`)
        this.deleteCompany.show = false
        this.deleteCompany.loading = false
        this.$service.$emit('alert-modal', '업체가 삭제되었습니다')
        this.getManagers()
      }
      else {
        this.deleteCompany.show = false
      }
      return;
    }
  },
  mounted () {
    this.getManagers()
  },
  data () {
    return {
      selected: null,
      loading: false,
      filter: null,
      search: null,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0
      },
      list: [],
      memos: [],
      memodlg: {
        show: false
      },
      company: {
        show: false,
        loading: false,
        rules: {
          company_name: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('회사이름을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9가-힣]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          website: [
            {validator: (r, v, cb) => { if (v && !/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig.test(v)) cb(new Error('올바른 이메일을 적어주세요')); else cb() }}
          ],
          name: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('담당자 이름을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9가-힣]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          email: [
            {validator: (r, v, cb) => { if (v && !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(v)) cb(new Error('올바른 이메일을 입력해 주세요')); else cb() }}
          ],
          phone: [
            {validator: (r, v, cb) => { if (v && !/^[0-9-]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ]
        },
        form: {
          pk: null,
          company_name: '',
          website: '',
          name: '',
          email: '',
          phone: '',
          enable: 'N',
          join_date: this.$service.moment().format('YYYY-MM-DD HH:mm:ss')
        }
      },
      register: {
        show: false,
        loading: false,
        modal: false,
        company: {},
        rules: {
          mgrid: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('아이디를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          mgrpw: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('비밀번호를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (v.length < 4) cb(new Error('4자 이상 입력해 주세요')); else cb(); }}
          ],
          name: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('담당자 이름을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9가-힣]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          email: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('담당자 이메일을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (v && !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(v)) cb(new Error('올바른 이메일을 입력해 주세요')); else cb() }}
          ]
        },
        form: {
          mgrid: '',
          mgrpw: '',
          name: '',
          email: ''
        }
      },
      deleteCompany: {
        show: false,
        loading: false,
        company: {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-information {
  list-style: none;
  padding: 0; margin: 0;

  > li {
    padding: 4px 10px;
    > div { display: inline-block; }
    > .label {
      width: 160px;
      color: #a0a0a0;
    }
  }
}
.data-pagination {
  text-align: center;
  background-color: white;
  padding: 4px 10px;
}

.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}

.company-name {
  cursor: pointer;
  &.active { color: red }
  &:hover {
    text-decoration: underline;
  }
}

.box-card {
  margin-bottom: 10px;
}
.card-header {
  font-size: 12px;
  color: #bfbfbf;

  .author {
    float: right;
  }
}
.card-body {
  white-space: pre-wrap;
  font-size: 13px;
  color: #828282;
  line-height: 21px;
  padding: 10px 5px;
  cursor: pointer;
}
// .card-edit {}
.card-edit-func {
  padding: 10px 0;
}
.card-edit-form /deep/ textarea {
  font-family: 'Malgun Gothic', sans-serif;
}
.user-type-icon {
  vertical-align: middle;
  font-size: 18px;
}
.user-type-admin { color: #ffb300; }
.user-type-user { color: #c7c7c7; }

.delete-memo-btn {
  cursor: pointer;
  &:hover { color:red; }
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.memo-close {
  display: block;
  padding: 6px;
  cursor: pointer;
}

.company-info-table {
  th, td { padding: 10px 0; }
  th { text-align: left }
}
</style>
